<style lang="scss">
    .events-by-status-template {
        .ivu-affix{
            width: 100% !important
        }
    }
</style>

<template>
  <div class="events-by-status-template">
      <Card shadow :padding="10" :style="{borderRadius: '0'}">
        <div class="ivu-input-wrapper ivu-input-type">
          <i class="ivu-icon ivu-icon-search ivu-input-icon ivu-input-icon-normal"></i>
          <input autocomplete="off" spellcheck="false" type="text" placeholder="Search..."
            v-model="filter"
            class="ivu-input">
        </div>
      </Card>
    <Row type="flex" justify="center">
        <span style="display: flex;height: 50vh;align-items: center;justify-content: center;" v-if="events.length == 0"> No {{listType}} events</span>
      <Col :span="24" v-for="(item, k) in orderedSelections" :key="k">
        <ResourceListItemComponent :item="item"></ResourceListItemComponent>
      </Col>
    </Row>
  </div>
</template>

<script>
import _ from 'lodash'
import ResourceListItemComponent from '@/components/ResourceMainAdvocaciesComponent'

export default {
  name: 'ResrouceByType',
  components: {
    ResourceListItemComponent
  },
  props:{
    type: String, required: false, default: "default"
  },
  data() {
    return {
      filter: ''
    }
  },
  computed: {
    userInfo: {
      get() { return this.$store.state.user.info }
    },
    listType: {
      get() { 
        if(this.type == 'accepted'){
          return 'joined'
        }else if(this.type == 'pending'){
          return 'invited'
        }else if(this.type == 'interested'){
          return 'interested'
        }else{
          return ''
        }
      }
    },
    resrouceByType: {
      get() {
        return this.$store.state.user.resrouceByType.careplan || []
      }
    },
    events: {
        get() {
            if(this.type == 'accepted' && this.$store.state.events.joinedEvents){
              return this.$store.state.events.joinedEvents.data;
            }else if(this.type == 'pending' && this.$store.state.events.pendingEvents){
              return this.$store.state.events.pendingEvents.data;
            }else if(this.type == 'interested' && this.$store.state.events.interestedEvents){
              return this.$store.state.events.interestedEvents.data;
            }else
              return this.$store.state.events.joinedEvents.data;
        }
    },
    orderedSelections: function () {
      // var list = this.events.filter((list) => {
      //   return list.title.toLowerCase().includes(this.filter.toLowerCase());
      // });
      // return _.orderBy(list,'title');

      return this.events
    }
  },
  mounted() {
    this.$store.dispatch('events/getAllEvents', 1)
    this.$store.dispatch('events/getListOfEvents','accepted')
    this.$store.dispatch('events/getListOfEvents','pending')
    this.$store.dispatch('events/getInterestedEvents')
    // this.$store.dispatch('user/getResourceByType', {type: this.$route.params.groupType});
  }
}
</script>
